import {GET_AGENT_POLICIES, SET_ACTIVE_POLICY} from '../actions/policies';

const initialState = {
    personalPolicies: [],
    commercialPolicies: [],
    activePolicy: null
};

export const policiesReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_AGENT_POLICIES:
            return {...state, personalPolicies: action.personalPolicies, commercialPolicies: action.commercialPolicies};
        case SET_ACTIVE_POLICY:
            return {...state, activePolicy: action.policy};
        default:
            return {...state};
    }
};